import { render, staticRenderFns } from "./SendEgiftPanelSuccess.vue?vue&type=template&id=2cdb54f1&scoped=true"
import script from "./SendEgiftPanelSuccess.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelSuccess.vue?vue&type=style&index=0&id=2cdb54f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb54f1",
  null
  
)

export default component.exports